module.exports = __webpack_public_path__ + "img/earphone.36a195af.png";